import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight, Users, Clock } from 'lucide-react';

function Calendar() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [recurringEvents, setRecurringEvents] = useState([]);
  const [oneTimeEvents, setOneTimeEvents] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const months = [
    'ஜனவரி', 'பிபஂரவரி', 'மார்சஂ', 'ஏபஂரலஂ', 'மே', 'ஜூனஂ',
    'ஜூலை', 'ஆகஸஂடஂ', 'செபஂடமஂபரஂ', 'அகஂடோபரஂ', 'நவமஂபரஂ', 'டிசமஂபரஂ'
  ];

  const daysOfWeek = ['ஞாயிறு', 'திஙஂகளஂ', 'செவஂவாயஂ', 'புதனஂ', 'வியாழனஂ', 'வெளஂளி', 'சனி'];
  const mobiledaysOfWeek = ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'];

  const fetchCalendarData = useCallback(async () => {

    try {
      setLoading(true);
      setError(null);
      
      // Recurring Events - Repeat every year (MM-DD format)
      const mockRecurringEvents = [
        { id: 1, title: 'குடியரசு தினமஂ', date: '01-26' },
        { id: 2, title: 'சுதந்திர தினமஂ', date: '08-15' },
        { id: 3, title: 'காந்தி ஜெயந்தி', date: '10-02' },
        { id: 4, title: 'தேவர் ஜெயந்தி', date: '10-30' },
        { id: 5, title: 'அடல் பிஹாரி வாஜ்பாய் நினைவு தினமஂ', date: '08-16' },
        { id: 6, title: 'கருபஂபு தினமஂ (தீவிரவாத தாகஂகுதலஂகளஂ)', date: '02-14' },
        { id: 7, title: 'ஏ. பி. ஜே. அப்துல் கலாம் நினைவு தினமஂ', date: '07-27' },
        { id: 8, title: 'திருப்பூர் குமரன்', date: '01-11' },
        { id: 9, title: 'காமராஜரஂ நினைவு தினமஂ', date: '10-02' },
        { id: 10, title: 'சர்வதேச யோகா தினம்', date: '06-21' },
        { id: 11, title: 'Dr ஷ்யாமா பிரசாத் முகர்ஜி நினைவு தினமஂ', date: '06-23' }
      ];

      // One-time Events - Specific date (YYYY-MM-DD format)
      const mockOneTimeEvents = [
        { id: 1, title: 'இளந்தாமரை மாநாடு', date: '2026-02-08', start_time: '04:00', place: 'கொடிசியா - கோயமஂபுதஂதூரஂ' },
        { id: 2, title: 'தேசிய ஜனநாயக கூடஂடணி பொதுகஂகூடஂடமஂ', date: '2026-03-01', start_time: '', place: 'மதுரை' },
        { id: 3, title: 'தேசிய ஜனநாயக கூடஂடணி பொதுகஂகூடஂடமஂ', date: '2026-03-06', start_time: '', place: 'வேலுாரஂ' },
        { id: 4, title: 'சடஂடமனஂற தேரஂதலஂ வாகஂகுபஂபதிவு', date: '2026-04-23', start_time: '7.00 AM', place: '' },
        { id: 5, title: 'சடஂடமனஂற தேரஂதலஂ வாகஂகு எணஂணிகஂகை', date: '2026-05-04', start_time: '8.00 AM', place: '' },
      ];

      // Birthdays - Repeat every year (YYYY-MM-DD format, year from birth_date)
      const mockBirthdays = [
        { id: 1, name: 'நரேந்திர மோடி', birth_date: '1950-09-17', photo: '' },
        { id: 2, name: 'அமித் சா', birth_date: '1964-10-22', photo: '' },
        { id: 3, name: 'அடல் பிஹாரி வாஜ்பாய்', birth_date: '1924-12-25', photo: '' },
        { id: 4, name: 'எல்.கே.அத்வானி', birth_date: '1927-11-08', photo: '' },
        { id: 5, name: 'நயினார் நாகேந்திரன்', birth_date: '1960-10-16', photo: '' },
        { id: 6, name: 'பசும்பொன் முத்துராமலிங்க தேவர்', birth_date: '1908-10-30', photo: '' },
        { id: 7, name: 'நேதாஜி சுபாஷ் சந்திர போஸ்', birth_date: '1897-01-23', photo: '' },
        { id: 8, name: 'காமராஜரஂ', birth_date: '1903-07-15', photo: '' },
        { id: 9, name: 'சி. பி. ராதாகிருஷ்ணன்', birth_date: '1957-05-04', photo: '' },
        { id: 10, name: 'முரளி மனோகர் ஜோஷி', birth_date: '1934-01-05', photo: '' },
        { id: 11, name: 'ஏ. பி. ஜே. அப்துல் கலாம்', birth_date: '1931-10-15', photo: '' },
        { id: 12, name: 'வானதி சீனிவாசன்', birth_date: '1970-06-06', photo: '' },
        { id: 13, name: 'திருப்பூர் குமரன்', birth_date: '1904-10-04', photo: '' },
        { id: 14, name: 'L. முருகனஂ', birth_date: '1977-05-29', photo: '' },
        { id: 15, name: 'Dr ஷ்யாமா பிரசாத் முகர்ஜி', birth_date: '1901-07-06', photo: '' }
      ];

      setRecurringEvents(mockRecurringEvents);
      setOneTimeEvents(mockOneTimeEvents);
      setBirthdays(mockBirthdays);
    } catch (error) {
      console.error('Error fetching calendar data:', error);
      setError('Failed to load calendar data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCalendarData();
  }, [fetchCalendarData]);

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  };

  const getEventsForDate = (date) => {
    if (!date) return { recurringEvents: [], oneTimeEvents: [], birthdays: [] };
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fullDateStr = `${year}-${month}-${day}`;
    const monthDay = `${month}-${day}`;
    
    const dayRecurringEvents = recurringEvents.filter(e => e.date === monthDay);
    const dayOneTimeEvents = oneTimeEvents.filter(e => e.date === fullDateStr);
    const dayBirthdays = birthdays.filter(b => {
      const birthMonthDay = b.birth_date.substring(5);
      return birthMonthDay === monthDay;
    });
    
    return { 
      recurringEvents: dayRecurringEvents, 
      oneTimeEvents: dayOneTimeEvents, 
      birthdays: dayBirthdays 
    };
  };

  const previousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
  };

  const isToday = (date) => {
    if (!date) return false;
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  };

  const days = getDaysInMonth(currentDate);

  return (
    <div>
      <div className="bg-gradient-to-r from-orange-600 to-orange-500 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center mb-4">
            <Users className="w-10 h-10 mr-4" />
            <h1 className="text-4xl font-bold">முகஂகிய நிகழஂவுகளஂ</h1>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {error && (
          <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded">
            <p className="text-sm text-red-700">{error}</p>
          </div>
        )}

        {loading ? (
          <div className="flex justify-center items-center py-32">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500"></div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white p-6">
              <div className="flex items-center justify-between">
                <button
                  onClick={previousMonth}
                  className="p-2 hover:bg-orange-700 rounded-lg transition-colors"
                >
                  <ChevronLeft className="w-6 h-6" />
                </button>
                
                <h2 className="text-2xl font-bold">
                  {months[currentDate.getMonth()]} {currentDate.getFullYear()}
                </h2>
                
                <button
                  onClick={nextMonth}
                  className="p-2 hover:bg-orange-700 rounded-lg transition-colors"
                >
                  <ChevronRight className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-7 bg-gray-100 border-b">
              {daysOfWeek.map((day, index) => (
                <div
                  key={index}
                  className="p-2 sm:p-3 text-center font-semibold text-gray-700 text-sm border-r last:border-r-0"
                >
                  {/* Mobile */}
                  <span className="block sm:hidden">
                    {mobiledaysOfWeek[index]}
                  </span>

                  {/* Tablet & Desktop */}
                  <span className="hidden sm:block">
                    {day}
                  </span>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-7">
              {days.map((date, index) => {
                const { recurringEvents: dayRecurringEvents, oneTimeEvents: dayOneTimeEvents, birthdays: dayBirthdays } = getEventsForDate(date);
                const allEvents = [...dayRecurringEvents, ...dayOneTimeEvents];
                
                return (
                  <div
                    key={index}
                    className={`min-h-24 md:min-h-32 p-2 border-r border-b last:border-r-0 ${
                      !date ? 'bg-gray-50' : 'bg-white hover:bg-orange-50'
                    } ${isToday(date) ? 'ring-2 ring-orange-500 ring-inset' : ''} transition-colors cursor-pointer`}
                    onClick={() => date && setSelectedDate(date)}
                  >
                    {date && (
                      <>
                        <div className={`text-sm font-semibold mb-1 ${
                          isToday(date) ? 'bg-orange-500 text-white w-7 h-7 rounded-full flex items-center justify-center' : 'text-gray-700'
                        }`}>
                          {date.getDate()}
                        </div>
                        
                        <div className="space-y-1">
                          {allEvents.map((event) => (
                            <div
                              key={event.id}
                              className="bg-blue-100 text-blue-800 text-xs p-1 rounded flex items-center gap-1 truncate"
                              title={event.title}
                            >
                              <Clock className="w-3 h-3 flex-shrink-0" />
                              <span className="truncate">{event.title}</span>
                            </div>
                          ))}
                          
                          {dayBirthdays.map((birthday) => (
                            <div
                              key={birthday.id}
                              className="bg-pink-100 text-pink-800 text-xs p-1 rounded flex items-center gap-1"
                              title={`${birthday.name}'s Birthday`}
                            >
                              {/* <img
                                src={birthday.photo}
                                alt={birthday.name}
                                className="w-4 h-4 rounded-full flex-shrink-0"
                              /> */}
                              <span className="truncate">🎂 {birthday.name}</span>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {selectedDate && (
          <div className="mt-8 bg-white rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-800">
                {selectedDate.toLocaleDateString('ta-IN', { 
                  weekday: 'long', 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </h3>
              <button
                onClick={() => setSelectedDate(null)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ✕
              </button>
            </div>

            {(() => {
              const { recurringEvents: dayRecurringEvents, oneTimeEvents: dayOneTimeEvents, birthdays: dayBirthdays } = getEventsForDate(selectedDate);
              const allDayEvents = [...dayRecurringEvents, ...dayOneTimeEvents];
              
              if (allDayEvents.length === 0 && dayBirthdays.length === 0) {
                return (
                  <p className="text-gray-500 text-center py-4">
                    இந்த நாளில் எந்த நிகழ்வுகளும் இல்லை
                  </p>
                );
              }

              return (
                <div className="space-y-4">
                  {allDayEvents.length > 0 && (
                    <div>
                      <h4 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                        <Clock className="w-5 h-5 text-blue-600" />
                        நிகழ்வுகள்
                      </h4>
                      <div className="space-y-2">
                        {dayRecurringEvents.map((event) => (
                          <div key={event.id} className="bg-green-50 p-3 rounded-lg border-l-4 border-green-500">
                            <div className="flex items-center gap-2">
                              {/* <span className="text-xs bg-green-200 text-green-800 px-2 py-1 rounded-full font-semibold">
                                ஆண்டுதோறும்
                              </span> */}
                            </div>
                            <div className="font-semibold text-green-900 mt-2">{event.title}</div>
                          </div>
                        ))}
                        
                        {dayOneTimeEvents.map((event) => (
                          <div key={event.id} className="bg-blue-50 p-3 rounded-lg border-l-4 border-blue-500">
                            <div className="font-semibold text-blue-900">{event.title}</div>
                            {event.start_time && (
                              <div className="text-sm text-blue-700 mt-1">
                                Time: {event.start_time}
                              </div>
                            )}
                            <div className="text-xs text-blue-600 mt-1">
                              {new Date(event.date).toLocaleDateString('en-GB')}
                            </div>
                            <div className="text-xs text-blue-600 mt-1">
                              {event.place}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {dayBirthdays.length > 0 && (
                    <div>
                      <h4 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                        <span className="text-xl">🎂</span>
                        பிறந்தநாள்கள்
                      </h4>
                      <div className="space-y-2">
                        {dayBirthdays.map((birthday) => (
                          <div key={birthday.id} className="bg-pink-50 p-3 rounded-lg flex items-center gap-3">
                            {/* <img
                              src={birthday.photo}
                              alt={birthday.name}
                              className="w-12 h-12 rounded-full object-cover"
                            /> */}
                            <div>
                              <div className="font-semibold text-pink-900">{birthday.name}</div>
                              <div className="text-sm text-pink-700">
                                🎂 பிறந்தநாள் வாழ்த்துக்கள்!
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}

        <div className="mt-6 bg-white rounded-lg shadow p-4">
          <h4 className="font-semibold text-gray-700 mb-3">குறிப்பு</h4>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-100 border-2 border-green-500 rounded"></div>
              <span className="text-sm text-gray-600">பொது நிகழ்வுகள்</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-blue-100 border-2 border-blue-500 rounded"></div>
              <span className="text-sm text-gray-600">கடஂசி நிகழ்வுகள்</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-pink-100 rounded"></div>
              <span className="text-sm text-gray-600">பிறந்தநாள்கள்</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
              <span className="text-sm text-gray-600">இன்றைய தேதி</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Calendar;